import FieldEditor from "editor/FieldEditor";

export default class FieldEditorNumber extends FieldEditor {

    create() {
        const $input = this.$input = eotwJSXFactory('input', {type: "number", className: this.settings.context === "admin-form" ? "admin-form__input" : "admin-editor admin-editor--text"});
        let value = this.$element.text();

        if (this.settings.required) {
            this.settings.optional = false;
        }

        if (this.settings.optional) {
            $input.attr("data-optional", true);
        }

        if (!value && this.settings.default) {
            value = this.settings.default;
        }

        this.setValue(value);

        this.$input.on("keyup change blur", () => {
            let value = this.getValue();
            if (value !== this.lastValue) {
                this.emit("change", value);
                this.valid();
            }
        });

        if ("string" === typeof this.settings.name) {
            $input.attr("name", this.settings.name);
        }

        if ("object" === typeof this.settings.attributes) {
            $input.attr(this.settings.attributes);
        }

        this.$element.html($input);
    }

    destroy() {
        super.destroy();

        this.$element.text(this.getValue());
    }

    /**
     *
     * @return {number}
     */
    getValue() {
        return parseFloat(this.$input.val());
    }

    valid() {
        let valid = this.$element.is("[data-optional]") || !isNaN(this.getValue());

        if (!valid) {
            this.$input.addClass("admin-editor--invalid");
        } else {
            this.$input.removeClass("admin-editor--invalid");
        }

        return valid;
    }

    focus() {
        this.$input.focus();
    }

    setValue(value) {
        this.lastValue = value;
        this.$input.val(value);
    }

    getDefaultSettings() {
        return {
            attributes: {},
            name: null,
            context: 'form',
            default: null,
            optional: true,
        };
    }
}

FieldEditor.register_editor("number", FieldEditorNumber);

